import {EXPERIMENTAL_TABLE_SHORTCUTS, TABLE_SHORTCUTS} from 'notebook/tables/TableShortcuts';
import {ShortcutDescription} from 'util/Keyboard';

export const TABLE_SHORTCUT_DESCRIPTIONS: Array<ShortcutDescription> = TABLE_SHORTCUTS.map(
  (shortcut) => shortcut.description
);

export const EXPERIMENTAL_TABLE_SHORTCUT_DESCRIPTIONS: Array<ShortcutDescription> =
  EXPERIMENTAL_TABLE_SHORTCUTS.map((shortcut) => shortcut.description);

export const NOTEBOOK_SHORTCUTS: Array<ShortcutDescription> = [
  {
    description: 'Copy',
    shortcut: {normalizedShortcutText: 'Ctrl + C'},
  },
  {
    description: 'Cut',
    shortcut: {normalizedShortcutText: 'Ctrl + X'},
  },
  {
    description: 'Paste',
    shortcut: {normalizedShortcutText: 'Ctrl + V'},
  },
  {
    description: 'Undo',
    shortcut: {normalizedShortcutText: 'Ctrl + Z'},
  },
  {
    description: 'Redo',
    shortcut: {normalizedShortcutText: 'Ctrl + Shift + Z'},
    alternativeShortcuts: [{normalizedShortcutText: 'Ctrl + Y'}],
  },
];

export const FORMATTING_SHORTCUTS: Array<ShortcutDescription> = [
  {
    description: 'Bold',
    shortcut: {normalizedShortcutText: 'Ctrl + B'},
  },
  {
    description: 'Italic',
    shortcut: {normalizedShortcutText: 'Ctrl + I'},
  },
  {
    description: 'Underline',
    shortcut: {normalizedShortcutText: 'Ctrl + U'},
  },
  {
    description: 'Strikethrough',
    shortcut: {normalizedShortcutText: 'Ctrl + Shift + X'},
  },
  {
    description: 'Link',
    shortcut: {normalizedShortcutText: 'Ctrl + K'},
  },
  {
    description: 'Monospace',
    shortcut: {normalizedShortcutText: 'Ctrl + Shift + K'},
  },
  {
    description: 'Symbol',
    shortcut: {normalizedShortcutText: 'Ctrl + ;'},
  },
  {
    description: 'Superscript',
    shortcut: {normalizedShortcutText: 'Ctrl + .'},
  },
  {
    description: 'Subscript',
    shortcut: {normalizedShortcutText: 'Ctrl + Shift + .'},
  },
  {
    description: 'Insert section/day',
    shortcut: {normalizedShortcutText: 'Ctrl + \\'},
  },
  {
    description: 'Cycle header style',
    shortcut: {normalizedShortcutText: 'Ctrl + `', skipOsTranslation: true},
  },
];

export const WORKSPACE_SHORTCUTS: Array<ShortcutDescription> = [
  {
    description: 'Switch to next tab',
    shortcut: {normalizedShortcutText: 'Ctrl + Shift + 0'},
  },
  {
    description: 'Switch to previous tab',
    shortcut: {normalizedShortcutText: 'Ctrl + Shift + 9'},
  },
  {
    description: 'Show keyboard shortcuts',
    shortcut: {normalizedShortcutText: 'Ctrl + ?'},
  },
];
